export default {"src":"/_next/static/media/Hide.7adf13ec.svg","height":16,"width":16};